import React from 'react';

import { FormattedMessage, type MessageDescriptor } from 'react-intl';

export const formatText = (text: MessageDescriptor | string): string | React.JSX.Element => {
	return typeof text === 'string' ? text : <FormattedMessage {...text} />;
};

/**
 * Utility method to help sorting string alphabetically.
 * @param direction
 * @returns positive or negative number
 */
export const sortAlphabetically = (direction: 'asc' | 'desc') => (a: string, b: string): number => {
	const aLower = a.toLowerCase();
	const bLower = b.toLowerCase();

	if (direction === 'asc') {
		return aLower.localeCompare(bLower);
	}
	return bLower.localeCompare(aLower);
};

/**
 * Converts an array of ATI strings to a comma-separated parameter value.
 * Returns undefined if the array is null, undefined, or empty.
 *
 * @param atiArray - Array of ATI strings (e.g., ['ati:confluence:page', 'ati:jira:issue'])
 * @returns Comma-separated string or undefined
 *
 * @example
 * atiArrayToParams(['ati:confluence:page', 'ati:jira:issue']) // 'ati:confluence:page,ati:jira:issue'
 * atiArrayToParams([]) // undefined
 * atiArrayToParams(undefined) // undefined
 */
export const atiArrayToParams = (atiArray?: string[]): string | undefined => {
	return atiArray && atiArray.length > 0 ? atiArray.join(',') : undefined;
};
